import { render, staticRenderFns } from "./Questionnaires.vue?vue&type=template&id=a7f2cafc&"
import script from "./Questionnaires.vue?vue&type=script&lang=js&"
export * from "./Questionnaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports